import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    // if (!historyItems || !historyItems.length) {
    //     return
    // }

    useEffect(()=>{
        Nosto.reloadCart(['nosto-preautocomplete','nosto-ocp-preautocomplete'])
    })

    return (
        <div class="ns-pt-0 ns-pl-5 ns-pr-5 ns-pb-5 ns-autocomplete ns-preautocomplete ns-absolute ns-d-md-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto" >
            <div class="search__featured-collections search__initial ns-d-block ns-pt-0" style="">
                <div class="nosto_element" id="nosto-preautocomplete"></div>
            </div>
            <div class="nosto_element search__featured-collections-grid" id="nosto-ocp-preautocomplete" style="padding-top:0px"></div>
        </div>
    )
}
